module.exports = __webpack_public_path__ + "img/m_2.3292e82a.jpg";